// @flow

import {
  OPEN_EMAIL_CHANNEL_CAPTURE,
  CLOSE_EMAIL_CHANNEL_CAPTURE,
  OPEN_WEB_PUSH_CHANNEL_CAPTURE,
  CLOSE_WEB_PUSH_CHANNEL_CAPTURE,
  CREATE_WEB_PUSH_USER_ON_SERVER,
} from './actionTypes';

export function openEmailChannelCapture(): TrovitAction {
  return {
    type: OPEN_EMAIL_CHANNEL_CAPTURE,
  };
}

export function closeEmailChannelCapture(): TrovitAction {
  return {
    type: CLOSE_EMAIL_CHANNEL_CAPTURE,
  };
}

export function openWebPushChannelCapture(): TrovitAction {
  return {
    type: OPEN_WEB_PUSH_CHANNEL_CAPTURE,
  };
}

export function closeWebPushChannelCapture(): TrovitAction {
  return {
    type: CLOSE_WEB_PUSH_CHANNEL_CAPTURE,
  };
}

export function createWebPushUserOnServer(payload: Object): TrovitAction {
  return {
    type: CREATE_WEB_PUSH_USER_ON_SERVER,
    payload,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/settings/actions.js